// Friendly labels for the pricing-log `source` field. Used both by the
// "Type" column and the Source filter so the two always read identically.
export const PRICING_LOG_TYPE_MAP: Record<string, string> = {
  api: "API",
  rates_now: "Rates.now",
  embed: "Embedded Widget",
  subscription_dashboard: "Rate Dashboard",
  user: "Dashboard User",
  drush: "Subscription Emails",
  unknown: "Unknown"
}

// Source value used when a log has no `source` set on the record.
export const UNKNOWN_SOURCE = "unknown"

export interface PricingLogSourceOption {
  id: string
  label: string
  description: string
  // Tailwind color stem (e.g. "blue") used to tint the dot + chip.
  color: string
}

// Ordered to mirror the backend's source-detection precedence
// (API key wins, `user` only when no request signal matched, `unknown` last).
export const PRICING_LOG_SOURCE_OPTIONS: PricingLogSourceOption[] = [
  {
    id: "api",
    label: PRICING_LOG_TYPE_MAP.api,
    description: "Authenticated via API key",
    color: "blue"
  },
  {
    id: "rates_now",
    label: PRICING_LOG_TYPE_MAP.rates_now,
    description: "rates.now consumer site",
    color: "indigo"
  },
  {
    id: "embed",
    label: PRICING_LOG_TYPE_MAP.embed,
    description: "Embedded widget (app key)",
    color: "violet"
  },
  {
    id: "subscription_dashboard",
    label: PRICING_LOG_TYPE_MAP.subscription_dashboard,
    description: "My subscription dashboard",
    color: "emerald"
  },
  {
    id: "user",
    label: PRICING_LOG_TYPE_MAP.user,
    description: "Logged-in session user",
    color: "amber"
  },
  {
    id: "drush",
    label: PRICING_LOG_TYPE_MAP.drush,
    description: "CLI / scheduled run",
    color: "slate"
  },
  {
    id: UNKNOWN_SOURCE,
    label: PRICING_LOG_TYPE_MAP.unknown,
    description: "No signal matched",
    color: "gray"
  }
]
